'use client'
import Image from "next/legacy/image";
import Reaptcha from "reaptcha";
import { useState } from "react";
import Script from "next/script";
import * as motion from "@/app/libraries/framer-motion";
import styles from "../styles/Contact.module.css";
// import { event } from "../../components/helper/google_analytics_events";

export default function Contact() {
  var bGdColor = require("../styles/config.json");
  var contact = "Contact us to learn more!.";
  var title = "IAMPRESENTING - Contact Us";
  const [contactPageState, setcontactPageState] = useState("info");
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [message, setMessage] = useState("");
  const [warning, setWarning] = useState("");
  const [verify, setVerify] = useState(false);
  const [done, setdone] = useState("Get in touch");
  const [submit, setSubmit] = useState("Submit");
  const [bgColor, setBgColor] = useState(
    "" + bGdColor.generalBackgroundColor + ""
  );
  const [bgPic, setBgPicture] = useState("");

  var templateParams = {
    from_name: name,
    from_email: email,
    message: message,
    ref_num: Date.now(),
  };

  //animate props
  const easing = [0.6, -0.5, 0.01, 0.99];
  const fadeInUp = {
    initial: {
      y: 60,
      opacity: 0,
    },
    animate: {
      y: 0,
      opacity: 1,
      transition: {
        duration: 0.6,
        ease: easing,
      },
    },
  };

  function PageState() {
    if (contactPageState == "info") {
      return (
        <motion.div className={styles.content} variants={fadeInUp}>
          <h1>Get in touch</h1>
          <p>
            Our intention is to provide software development, graphics design
            and web development services to meet your businesses demands.
            <br />
            <br />
            I Am Presenting can be that catalyst for your business.
            <br />
            <br />
            Take that step with us.
            <br />
            <br />
          </p>
          <p className={styles.mail}>Mail us: info@iampresenting.com</p>
          <hr className={styles.hrLine} size="4" />
          <motion.button
            whileHover={{ scale: 1.05 }}
            whileTap={{ scale: 0.95 }}
            onClick={() => ChangePageState()}
            className={styles.submitButton}
          >
            Request a quote
          </motion.button>
        </motion.div>
      );
    } else {
      return (
        <motion.div className={styles.content} variants={fadeInUp}>
          <h1>{done}</h1>
          {Form()}
          <motion.button
            whileHover={{ scale: 1.05 }}
            whileTap={{ scale: 0.95 }}
            className={styles.submitButton2}
            onClick={() => SendEmail()}
          >
            {submit}
          </motion.button>
        </motion.div>
      );
    }
  }

  function ChangePageState() {
    // event({ action: "Button Request Quote" });
    setcontactPageState("fillInContact");
    setdone("Get in touch");
    setWarning("");
    setSubmit("Submit");
    setBgColor(bGdColor.secondBackgroundColor);
    setBgPicture(bGdColor.backgroundTexture);
  }

  function Form() {
    if (warning != "Thank you for contacting us, we will contact you soon") {
      return (
        <div>
          <p>
            {contact}
            <br />
            We&apos;d love to help your business reach it&apos;s goals.
            <br />
            <br />
            Take that step with us.
            <br />
            <br />
          </p>
          <input
            className={styles.input}
            placeholder="Name & Surname"
            type="text"
            minLength={5}
            value={name}
            onChange={(e) => {
              setName(e.target.value);
            }}
            required
          />
          <br />
          <input
            className={styles.input}
            placeholder="Email"
            type="email"
            min={5}
            value={email}
            onChange={(e) => {
              setEmail(e.target.value);
            }}
            required
          />
          <br />
          <textarea
            className={styles.input}
            rows="2"
            placeholder="Message"
            min={5}
            type="text"
            value={message}
            onChange={(e) => {
              setMessage(e.target.value);
            }}
            required
          />
          <Reaptcha
            sitekey="6Len4KEfAAAAAI_8SQ2eA_8K2_hvBm1mMgKmcJRc"
            onVerify={(recaptchaResponse) => {
              // Do something
              setVerify(true);
            }}
            size="normal"
          />
          <p>{warning}</p>
          <br />
        </div>
      );
    } else {
      return <></>;
    }
  }

  function SendEmail() {
    if (submit == "Submit") {
      setWarning("Sending Email...");
      setdone("Get in touch");
      if (name != "" && email != "" && message != "" && verify == true) {
        if (/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email) === true) {
          try {
            fetch("/api/contact", {
              method: "POST",
              headers: {
                Accept: "application/json, text/plain, */*",
                "Content-Type": "application/json",
              },
              body: JSON.stringify(templateParams),
            }).then((res) => {
              if (res.status === 200) {
                setEmail("");
                setName("");
                setMessage("");
                setWarning(
                  "Thank you for contacting us, we will contact you soon"
                );
                setVerify(false);
                setdone(
                  "Thank you for contacting us, we will contact you soon"
                );
                setSubmit("Go Back");
              } else {
                console.log("FAILED...", res.toString());
                setWarning("Sorry Something went wrong, Please try again");
              }
            });
          } catch (err) {
            console.log("FAILED...", res.toString());
            setWarning("Sorry Something went wrong, Please try again");
          }
        } else {
          setWarning("Correct Email format required e.g 123@abc.com");
        }
      } else {
        setWarning("Please complete all fields");
      }
    } else {
      setcontactPageState("info");
      setBgColor("" + bGdColor.generalBackgroundColor + "");
      setBgPicture("");
    }
  }

  return (
    <motion.div
      key={title}
      exit={{ opacity: 0 }}
      initial="initial"
      whileInView="animate"
      className={styles.container}
    >
      <Script
        src="https://www.google.com/recaptcha/api.js"
        async
        defer
        strategy="worker"
      ></Script>
      <div
        className={styles.main}
        style={{
          backgroundColor: "" + bgColor + "",
          backgroundImage: "url(" + bgPic + ")",
        }}
      >
        <div className={styles.contentcontainer}>
          <motion.div className={styles.cubeWithBall} variants={fadeInUp}>
            <Image
              src="v1657142666/IAmPresenting/NavBar/klh4xiw7snkvlwzyo0cf.png"
              layout="responsive"
              height={"100%"}
              width={"100%"}
              className={styles.image}
              alt="IAmPresenting mission"
              priority
            />
          </motion.div>
          <motion.div className="sloganLine">
            <hr className="hrLine1" />
            <p className="slogan1">{bGdColor.slogan}</p>
            <hr className="hrLine2" />
            <p className="slogan2">{bGdColor.slogan}</p>
          </motion.div>
          <motion.div className={styles.tube} variants={fadeInUp}>
            <Image
              src="v1657142586/IAmPresenting/NavBar/hd2hhfeaebsh9fnev5mp.png"
              layout="responsive"
              height={"100%"}
              width={"100%"}
              className={styles.image}
              alt="IAmPresenting mission"
              priority
            />
          </motion.div>
          <motion.div className={styles.tubeSide} variants={fadeInUp}>
            <Image
              src="v1657142717/IAmPresenting/NavBar/ghdpqq4rzeb8qbzkipuc.png"
              layout="responsive"
              height={"100%"}
              width={"100%"}
              className={styles.image}
              alt="IAmPresenting mission"
              priority
            />
          </motion.div>
          <motion.div className={styles.gridDot} variants={fadeInUp}>
            <Image
              src="v1654900442/IAmPresenting/Home/fysfho5icnb2njjopimi.png"
              layout="responsive"
              height={"30%"}
              width={"80%"}
              className={styles.image}
              alt="IAmPresenting mission"
              priority
            />
          </motion.div>
          {PageState()}
        </div>
      </div>
    </motion.div>
  );
}
